import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolLpTranslator } from '@cbridge-packages/symbol-lp';
import { SymbolLpAction } from '../symbolLp.action';

type IDependencies = IClientApiDependencySegment;

export const loadSymbolLpEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolLpAction.load.started),
  switchMap((params) => {
    return dependencies.api.getLpSymbol(params).pipe(
      mergeMap((response) => {
        return [
          SymbolLpAction.load.done({ params, result: SymbolLpTranslator.fromApi(response) }),
        ];
      }),
      catchApiError((error) => {
        return [
          SymbolLpAction.load.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
